import { render, staticRenderFns } from "./SearchKeyWordDesc.vue?vue&type=template&id=55e0827e&scoped=true&"
var script = {}
import style0 from "./SearchKeyWordDesc.vue?vue&type=style&index=0&id=55e0827e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e0827e",
  null
  
)

export default component.exports